export default "__VITE_ASSET__Cp$TSuZl__"